import { Box, styled, Typography } from "@material-ui/core";

const Label = styled(Typography)(({ theme }) => ({
  fontSize: "0.7rem",
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: "0.07em",
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(1.25),
}));

export const SectionHeading: FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <Box>
    <Label variant="overline">{children}</Label>
  </Box>
);
